<div class="group/date">
    <div
        class="border-grey-400 group-hover/date:border-blue relative box-border flex h-[51px] flex-wrap items-center border-2 transition-all focus-within:outline focus-within:outline-1"
        [ngClass]="{
            'border-red': error(),
        }"
        [attr.aria-describedby]="error() ? errorId : null"
    >
        <button
            class="relative flex w-full grow flex-col justify-center text-black outline-none"
            [attr.aria-expanded]="overlayOpen()"
            (click)="openOverlay($event)"
        >
            <span
                class="absolute bg-white leading-27 text-black transition-all duration-300"
                [ngClass]="{
                    'text-12 -top-14 left-0 px-12': control().value,
                    'text-16 px-16': !control().value,
                    'text-red': error(),
                }"
            >
                <ng-content />
            </span>
            @if (control().value; as v) {
                <span class="text-16 absolute bg-white px-16 leading-27 text-black transition-all duration-300">
                    {{ v | date: 'dd. MMMM yyyy' }}
                </span>
            }
            <i
                class="icon-calender text-24 group-hover/date:text-blue absolute top-1/2 right-16 -translate-y-1/2 text-black transition-all duration-300"
                [ngClass]="{
                    'text-red': error(),
                }"
                aria-hidden="true"
            ></i>
        </button>
    </div>
    <p class="text-12 text-red relative left-0 leading-16" [id]="errorId" role="alert">
        @if (!control().valid && control().value) {
            {{ errorValidation() }}
        }
        @if (control().touched && !control().valid && !control().value) {
            {{ errorRequired() }}
        }
    </p>
</div>
